import React, { FC } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { NotificationListStyled } from './notification-list.styled';
import { Notification } from './notification';
import { NotificationListProps } from './types';

export const NotificationList: FC<NotificationListProps> = props => {
  const { items, timeout } = props;
  return (
    <NotificationListStyled {...{ items, timeout }}>
      <TransitionGroup>
        {items.map(props => (
          <CSSTransition key={props.id} timeout={timeout} classNames="animation" addEndListener={() => false}>
            <Notification {...props} />
          </CSSTransition>
        ))}
      </TransitionGroup>
    </NotificationListStyled>
  );
};

NotificationList.defaultProps = {
  timeout: {
    enter: 150,
    exit: 100,
  },
};

NotificationList.displayName = 'NotificationList';
